import { useFormContext } from "react-hook-form";
import { useEffect } from "react";

const BookFromArtistCalendarFormHelper = ({ resetUserInputs }: any) => {
  const form = useFormContext();

  useEffect(() => {
    form.setValue("user_id", null);
    form.setValue("phone_number_search", null);
    form.setValue("phone_number", null);
    form.setValue("first_name", null);
    form.setValue("last_name", null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetUserInputs]);

  return <div />;
};

export default BookFromArtistCalendarFormHelper;
